module.exports = __webpack_public_path__ + "img/blog-7-2.da46e1f3.webp";